
export default {
  auth: null,
  expired: {
    status: false,
    days: null,
  },
};



// WEBPACK FOOTER //
// ./src/stores/auth/state.js